export const SESSION_EXPIRED_FLAG = 'lge.sessionExpired';
